export default "__VITE_ASSET__b8511628__"